module.exports = __webpack_public_path__ + "static/media/timeline.dc1aa04c.svg";